import { SearchItem } from "../../../../../interface/SearchInterface";
import "../../../Index.scss";
import { Env } from "../../../../../utils/globalUtilities";

export const LearningSearchResult = ({learningItem, index, onClickPreview}:any) => {
    return (
      <div className="group-list-contents" key={`LearningSearchResult${index}`}  >
                        <div className="group-row">
                          <span className="group-list-title">
                            <ul className="group-list-places">
                              <li>
                                {" "}
                                <img
                                  className="group-list-icon logoicon"
                                  src="https://cdn.taxmann.com/taxmann-images/taxmann-premium/learning-icon-n1.png"
                                ></img>{" "}
                              </li>
                              <li>Taxmann Learning </li>
                              {
                                learningItem?.categoryUrl ?
                                  <>
                                    <li> <i className="pi pi-angle-right"></i> </li>
                                    <li>  {learningItem?.categoryUrl}  </li>
                                  </>
                                  : ''
                              }
                              <li> <i className="pi pi-angle-right"></i> </li>
                              <li>  {learningItem?.categoryName}  </li>
                              <li> <i className="pi pi-angle-right"></i> </li>
                              <li>  {learningItem?.groupName}  </li>
                            </ul>
                          </span>
                          <div className="list-items">

                            <span className="list-item-thumb pointer">
                              <img src={learningItem?.image_url ? learningItem?.image_url : `${Env().REACT_APP_PRODUCT_ATTACHMENT_BASE_URL}learning_empty.png`}
                                onClick={() => onClickPreview(learningItem)}
                                onError={({ currentTarget }) => {
                                  currentTarget.onerror = null; // prevents looping
                                  currentTarget.src = `${Env().REACT_APP_PRODUCT_ATTACHMENT_BASE_URL}learning_empty.png`;
                                }}
                              />
                            </span>
                            <div className="list-item-contents">
                              <h2 className="list-item-h2 pointer" onClick={() => onClickPreview(learningItem)} >
                                {" "}
                                {learningItem?.secondLine}
                              </h2>
                              {
                                learningItem?.speakers_List?.length ?

                                  <span className="list-item-authors">
                                    <span className="author-images">
                                      <ul className="a-img-items">
                                        {
                                          learningItem?.speakers_List.map(
                                            (speaker: SearchItem, indexspeaker: number) => (
                                              <li key={`LearningSpeaker${index}${indexspeaker}`} > <img src={speaker?.image_url ? speaker?.image_url : `${Env().REACT_APP_PRODUCT_ATTACHMENT_BASE_URL}learning_empty.png`}
                                                onError={({ currentTarget }) => {
                                                  currentTarget.onerror = null; // prevents looping
                                                  currentTarget.src = `${Env().REACT_APP_PRODUCT_ATTACHMENT_BASE_URL}learning_empty.png`;
                                                }}
                                              /> </li>
                                            )
                                          )
                                        }
                                      </ul>
                                    </span>
                                    {" "}
                                    by {learningItem?.thirdLine}
                                  </span>
                                  : ''
                              }

                              {/* {
                                learningItem.date ?
                                  learningItem.categoryName ?
                                    <span className="list-item-texts">
                                      {" "}
                                      {learningItem.categoryName} &nbsp; | &nbsp;
                                      {learningItem.groupName} &nbsp; | &nbsp;
                                      {learningItem.date}
                                    </span>
                                    :
                                    <span className="list-item-texts">
                                      {" "}
                                      {learningItem.groupName} &nbsp; | &nbsp;
                                      {learningItem.date}
                                    </span>
                                  :
                                  learningItem.categoryName ?
                                    <span className="list-item-texts">
                                      {" "}
                                      {learningItem.categoryName} &nbsp; | &nbsp;
                                      {learningItem.groupName}
                                    </span>
                                    :
                                    <span className="list-item-texts">
                                      {" "}
                                      {learningItem.groupName}
                                    </span>
                              } */}
                            </div>
                          </div>
                        </div>
                      </div>
    )
}

export default LearningSearchResult


 